import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { useMergeRefs } from '@floating-ui/react';
import { createPolymorphicComponent, } from '../../helpers/react/polymorphicComponentTypes';
import { useVisualState } from '../VisualState';
import { useStyles } from '../../hooks/useStyles';
import { Elevation } from '../Elevation';
import { FocusRing } from '../FocusRing';
import { StateLayer } from '../StateLayer';
import { Base } from '../Base';
import { TouchTarget } from '../TouchTarget';
import { buttonBaseStyles } from './ButtonBase.styles';
export const ButtonBase = createPolymorphicComponent(forwardRef(function ButtonBase(props, forwardedRef) {
    const { as, styles, sx, innerStyles, visualState: visualStateProp, children, inwardFocusRing, readOnly, type = 'button', href, ...other } = props;
    const visuallyDisabled = other.disabled || readOnly;
    const { visualState, setRef: setVisualStateRef } = useVisualState(visualStateProp, { disabled: visuallyDisabled });
    const visualStateRef = useRef(null);
    const handleRef = useMergeRefs([
        forwardedRef,
        setVisualStateRef,
        visualStateRef,
    ]);
    const { combineStyles, getStyles, globalStyles, settings } = useStyles({
        name: 'ButtonBase',
        styles: [buttonBaseStyles, styles],
        visualState,
    });
    const rootElement = as ?? (href ? (settings?.linkAs ?? 'a') : 'button');
    return (_jsxs(Base, { as: rootElement, href: href, role: 'button', tabIndex: visuallyDisabled ? -1 : 0, type: type, ...other, visualState: visualState, sx: [
            globalStyles,
            combineStyles('host', visuallyDisabled && 'host$disabled'),
            sx,
        ], ref: handleRef, children: [_jsx(TouchTarget, { visualState: visualState, disabled: visuallyDisabled }), _jsx(Elevation, { styles: innerStyles?.elevation, disabled: visuallyDisabled }), _jsx("div", { ...getStyles('outline', visuallyDisabled && 'outline$disabled') }), _jsx("div", { ...getStyles('background', visuallyDisabled && 'background$disabled') }), visuallyDisabled ? null : (_jsx(FocusRing, { styles: innerStyles?.focusRing, for: visualStateRef, visualState: visualState, inward: inwardFocusRing })), _jsx(StateLayer, { styles: innerStyles?.stateLayer, for: visualStateRef, disabled: visuallyDisabled, visualState: visualState }), children] }));
}));
